var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"c-topic-list"},_vm._l((_vm.topics),function(topic){return _c('TopicCard',{key:topic.id,staticClass:"topic-item",attrs:{"topic":topic}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }